import { render, staticRenderFns } from "./PersonRelated.vue?vue&type=template&id=e5949d84&scoped=true"
import script from "./PersonRelated.vue?vue&type=script&lang=js"
export * from "./PersonRelated.vue?vue&type=script&lang=js"
import style0 from "./PersonRelated.vue?vue&type=style&index=0&id=e5949d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5949d84",
  null
  
)

export default component.exports